const isCoupon = (coupon) => coupon && Object.keys(coupon).length !== 0;

export default isCoupon;
